import axios from 'axios'

const fcts = {
  getDetails({activationdate, deactivationdate, alias}) {
    return axios
      .get(process.env.API + '/activity/details/' + activationdate + '/' + deactivationdate + '/' + alias + '/')
      .then(res => res.data)
  }
}

export default fcts



//////////////////
// WEBPACK FOOTER
// ./node_modules/@rocketfid/api/services/activity.js
// module id = null
// module chunks = 